import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import BoardsList from './components/Boards/BoardsList';
import Board from './components/Boards/Board';
import ProfileMain from './components/Profile/ProfileMain';
import Dashboard from './components/Dashboard/Dashboard';
import Application from './components/Applications/Application';
import ApplicationList from './components/Applications/ApplicationList';

import './custom.css'
import Admin from './components/Admin/Admin';
import BoardsAdminList from './components/Admin/Boards/BoardsAdminList';
import AddEditBoard from './components/Admin/Boards/AddEditBoard';
import SignIn from './components/SignIn';
import BoardMemberEdit from './components/Admin/BoardMembers/BoardMemberEdit';
import ProfilesAdminList from './components/Admin/Profiles/ProfilesAdminList';
import EditProfile from './components/Admin/Profiles/EditProfile';
import ReportsList from './components/Admin/Reports/ReportsList';
import MembershipExpiration from './components/Admin/Reports/MembershipExpiration';
import BoardVacancy from './components/Admin/Reports/BoardVacancy';
import AdminApplication from './components/Admin/Application/AdminApplication';
import Dropdowns from './components/Admin/Codes/Dropdowns';

import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

export default class App extends Component {
  constructor(props){
    super(props);

    this.state = { userId: null, token: null};
  }
  static displayName = App.name;

  render () {
    return (
      <Layout>
            <Route exact path='/' component={Home} />
            <Route exact path='/explore' component={BoardsList} />
            <Route exact path='/board/:id' component={Board} />
            <Route exact path='/admin' component={Admin} />
            <Route exact path='/admin/boards' render={() => <Admin children={<BoardsAdminList />} />} />
            <Route exact path='/profile/:googleId' component={ProfileMain} />
            <Route exact path='/signin' component={SignIn} />
            <Route exact path='/admin/boards/:id' render={() => <Admin children={<AddEditBoard />} />} />
            <Route exact path='/admin/boardmember/:id' render={() => <Admin children={<BoardMemberEdit />} />} />
            <Route exact path='/admin/application/:id' render={() => <Admin children={<AdminApplication />} />} />
            <Route exact path='/dashboard/:id' component={Dashboard} />
            <Route exact path='/application/:id' component={Application} />
            <Route exact path='/applicationlist/:id' component={ApplicationList} />
            <Route exact path='/admin/profiles' render={() => <Admin children={<ProfilesAdminList />} />} />
            <Route exact path='/admin/profiles/:id' render={() => <Admin children={<EditProfile />} />} />
            <Route exact path='/admin/reports' render={() => <Admin children={<ReportsList />} />} />
            <Route exact path='/admin/reports/membershipexpiration' render={() => <Admin children={<MembershipExpiration />} />} />
            <Route exact path='/admin/reports/boardvacancy' render={() => <Admin children={<BoardVacancy />} />} />
            <Route exact path='/admin/dropdowns' render={() => <Admin children={<Dropdowns />} />} />
      </Layout>
    );
  }
}
